/**
 * Dependency GraphQL Queries
 *
 * 7 queries for dependency management and DAG analysis
 */

import { gql } from '@apollo/client';
import { DEPENDENCY_FIELDS_FRAGMENT } from './fragments';

export const GET_DEPENDENCY = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  query GetDependency($tenantId: String!, $dependencyId: String!) {
    getDependency(tenantId: $tenantId, dependencyId: $dependencyId) {
      ...DependencyFields
    }
  }
`;

export const LIST_DEPENDENCIES_BY_WORKFLOW = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  query ListDependenciesByWorkflow(
    $workflowId: String!
    $limit: Int
    $cursor: String
  ) {
    listDependenciesByWorkflow(
      workflowId: $workflowId
      limit: $limit
      cursor: $cursor
    ) {
      items {
        ...DependencyFields
      }
      nextCursor
      hasMore
    }
  }
`;

export const GET_TASK_DEPENDENCIES = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  query GetTaskDependencies($taskId: String!) {
    getTaskDependencies(taskId: $taskId) {
      incoming {
        ...DependencyFields
      }
      outgoing {
        ...DependencyFields
      }
    }
  }
`;

export const BUILD_WORKFLOW_DAG = gql`
  query BuildWorkflowDag($workflowId: String!) {
    buildWorkflowDag(workflowId: $workflowId) {
      workflowId
      nodes
      edges {
        from
        to
        type
      }
      isValid
      validationErrors
    }
  }
`;

export const DETECT_CIRCULAR_DEPENDENCIES = gql`
  query DetectCircularDependencies($workflowId: String!) {
    detectCircularDependencies(workflowId: $workflowId) {
      hasCycles
      cycles
      cycleCount
    }
  }
`;

export const GET_CRITICAL_PATH = gql`
  query GetCriticalPath($workflowId: String!) {
    getCriticalPath(workflowId: $workflowId) {
      criticalPath
      totalDuration
      criticalTasks {
        id
        name
        earliestStart
        latestStart
        slack
      }
    }
  }
`;

export const VALIDATE_DEPENDENCY = gql`
  query ValidateDependency($input: CreateDependencyInput!) {
    validateDependency(input: $input) {
      isValid
      errors
      warnings
    }
  }
`;

